import { Head } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import TodoForm from "./_form"

interface Option {
  id: number
  name: string
}
interface Props {
  todo: Record<string, unknown>
  users: Option[]
  notifiable_users?: Option[]
  errors?: Record<string, string[]>
}
const breadcrumbs: BreadcrumbItem[] = [
  { title: "Marketing Todos", href: "/marketing_todos" },
  { title: "New", href: "/marketing_todos/new" },
]

export default function New({ todo, users, notifiable_users, errors }: Props) {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="New Marketing Todo" />
      <div className="p-6">
        <h1 className="mb-4 text-2xl font-semibold">New Marketing Todo</h1>
        <TodoForm
          todo={todo}
          users={users}
          notifiableUsers={notifiable_users}
          errors={errors}
        />
      </div>
    </AppLayout>
  )
}
